import React from 'react';
import { Card } from '../../../components/CssFrameworkComponents';
import SettingsToggleRow from '../components/SettingsToggleRow';
import { useAutoSaveSetting } from '../hooks/useAutoSaveSetting';
import { useOptimisticChecked } from '../hooks/useOptimisticChecked';
import { usePrerenderUser } from '../../../hooks/usePrerenderUser';
import { SETTINGS_RESTRICTED_ROLES } from '../settingsRoles';

const TITLE = 'Automatic Recaching';

const DESCRIPTIONS = [
  'If you deactivate automatic re-caching, you will temporarily pause automatic re-caching. This is useful if your website has problems or is temporarily unavailable.',
  "Caution: leaving this on for too long can affect your site's search engine rankings. Only use it briefly when needed.",
];

const DisableRecacheCard = () => {
  const { userPausedRecaching } = usePrerenderUser();
  const { save, status, retry } = useAutoSaveSetting();

  const recachingActive = !userPausedRecaching;
  const { checked, setPendingChecked } = useOptimisticChecked(recachingActive, status);

  const toggleRecaching = (nextChecked) => {
    setPendingChecked(nextChecked);
    save({ recachePaused: !nextChecked });
  };

  return (
    <Card title={TITLE}>
      <div className="col">
        <div className="row">
          {DESCRIPTIONS.map((description) => (
            <p key={description}>{description}</p>
          ))}
        </div>
        <SettingsToggleRow
          checked={checked}
          onChange={toggleRecaching}
          disabled={status === 'saving'}
          disabledFor={SETTINGS_RESTRICTED_ROLES}
          status={status}
          onRetry={retry}
        />
      </div>
    </Card>
  );
};

export default DisableRecacheCard;
